import { render, staticRenderFns } from "./card.vue?vue&type=template&id=6382cdfa&scoped=true&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"
import style0 from "./card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./card.vue?vue&type=style&index=1&id=6382cdfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382cdfa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LazyLoad: require('/builds/master/frontend/frontend-universe/components/lazy-load.vue').default,SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default,Avatar: require('/builds/master/frontend/frontend-universe/components/avatar.vue').default})
